import React from "react";

const Page3 = () => {
  const projects = [
    {
      title: "Calculator",
      description: "Built using JavaScript and React.",
      link: "https://akshitaladdha27.github.io/Calculator/",
      image: "/calculator.png",
    },
    {
      title: "Weather App",
      description:
        "A weather application built using React and the OpenWeatherMap API.",
      link: "https://rococo-marigold-27920e.netlify.app/",
      image: "/weather-app.png",
    },
    {
      title: "PDF Report Generation System",
      description: "This allows the creation of dynamic PDF reports.",
      link: "https://github.com/akshitaladdha27/pdf-management-system.git",
      image: "/pdf-managmenent-system.png",
    },
    {
      title: "TodoContextLocal",
      description: "In which data store in localStorage and build using react",
      link: "https://akshitaladdha27.github.io/Todocontextlocal/",
      image: "/todoapp.png",
    },
  ];

  return (
    <div className="min-h-screen px-5 py-10 bg-white  overflow-hidden">
      <div className="h-full w-full overflow-hidden bg-black rounded-[50px] relative">

        {/* Background video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover"
          src="/project-bg.mp4"
        />

        {/* Title */}
        <h1
          className="
            font-[anzo] uppercase text-blue-300 text-center pt- z-10
            absolute top-0 left-1/2 -translate-x-1/2
            text-[10vw]
            max-[768px]:text-[14vw]
            max-[480px]:text-[16vw]
          "
        >
          Projects
        </h1>

        {/* Projects Grid */}
        <div
          className="
            relative z-20
            mt-[30vh]
            max-[768px]:mt-[22vh]
            max-[480px]:mt-[17vh]
            px-10
            max-[640px]:px-4
          "
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {projects.map((proj, index) => (
              <div
                key={index}
                className="bg-gray-200 shadow-lg rounded-xl overflow-hidden transform hover:scale-105 transition duration-300"
              >
                <img
                  src={proj.image}
                  alt={proj.title}
                  className="w-full h-60 max-[640px]:h-44 object-cover"
                />

                <div className="p-3 flex flex-col justify-between h-[150px] max-[640px]:h-auto">
                  <div className="text-center">
                    <h3 className="text-xl max-[640px]:text-lg font-bold mb-2">
                      {proj.title}
                    </h3>
                    <p className="text-gray-600 text-lg max-[640px]:text-sm mb-2">
                      {proj.description}
                    </p>
                  </div>

                  <a
                    href={proj.link}
                    className="bg-blue-300 text-blue-900 text-base md:text-lg font-bold px-3  py-1 md:py-0 rounded-lg hover:bg-blue-200 transition w-max mx-auto"
                  >
                    Check it out
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* See more */}
          <div className="text-center mt-12 mb-5 ">
            <a
              href="https://github.com/akshitaladdha27?tab=repositories"
              target="_blank"
              rel="noopener noreferrer"
              className="
                inline-block bg-blue-300 text-blue-900 font-bold
                text-xl max-[640px]:text-base
                px-8 py-3 rounded-full
                hover:bg-blue-200 transition-colors
              "
            >
              See More Projects
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Page3;
